import { gql } from '@apollo/client';
import { client } from "graphql/client";

export const UPDATE_ACCOUNT_STATUS = gql`
    mutation UpdateAccountStatus($accountId: Long!, $status: Int!) {
        updateAccountStatus(accountId: $accountId, status: $status)
    }
`;

export interface UpdateAccountStatusResponse {
    updateAccountStatus: boolean;
}

export interface UpdateAccountStatusVariables {
    accountId: number;
    status: number;
}

export const accountStatusUpdateMutations = async (accountId: number, status: number): Promise<boolean> => {
    const { data } = await client.mutate<UpdateAccountStatusResponse, UpdateAccountStatusVariables>({
        mutation: UPDATE_ACCOUNT_STATUS,
        variables: { accountId, status }
    });
    
    return data!.updateAccountStatus;
}; 